import React from "react";
import "./Skills.css";
import SkillSection from "./SkillSection";
import { Fade } from 'react-awesome-reveal';

export default function Skills(props) {
  const theme = props.theme;
  return (
    <div className="main" id="skills">
      <div className="skills-header-div">
        <Fade direction="down" duration={1000}>
          <h1 className="skills-header" style={{ color: theme.text }}>
            a comprehensive overview of ajuanijustus
          </h1>
        </Fade>
      </div>
      <SkillSection theme={theme} />
    </div>
  );
}
